import React, { FC, memo, PropsWithChildren, ReactNode } from 'react';
import { Modal as AntdModal } from 'antd';
import classNames from 'classnames';
import { ReactComponent as CloseIcon } from 'shared/assets/icons/newIcons/CloseIcon.svg';
import s from './index.module.scss';

interface ModalProps extends PropsWithChildren {
  isOpen: boolean;
  onClose?: () => void;
  footer?: ReactNode;
  className?: string;
  centered?: boolean;
  closeIcon?: boolean | ReactNode;
  width?: number;
  paddingLess?: boolean;
  zIndex?: number;
  headerItems?: ReactNode;
  transparent?: boolean;
  isMobile?: boolean;
}

export const Modal: FC<ModalProps> = memo((props) => {
  const {
    isOpen,
    onClose,
    children,
    footer = false,
    className,
    centered = true,
    closeIcon = true,
    width,
    paddingLess = false,
    zIndex,
    headerItems,
    transparent = false,
    isMobile = false,
  } = props;

  const modalClass = classNames(s.modal, className, {
    [s.paddingLess]: paddingLess,
    [s.marginLess]: !footer,
    [s.transparent]: transparent,
    [s.mobile]: isMobile,
  });

  return (
    <AntdModal
      open={isOpen}
      onCancel={onClose}
      className={modalClass}
      footer={footer}
      centered={centered}
      closeIcon={closeIcon ? <CloseIcon className="w-10 h-10" /> : false}
      width={width}
      zIndex={zIndex}
    >
      {children}
      {headerItems}
    </AntdModal>
  );
});
